module.exports = __webpack_public_path__ + "img/swiper_04.7c709150.jpg";